import { LocationType } from "@freightsimple/generated-dashboard-openapi-client/models/LocationType";
import { ensureAccessorialsContain } from "@/Helpers/ensureAccessorialsContain";

// Some location types imply accessorials the customer would otherwise have to
// remember: a distribution warehouse always needs an appointment, and a
// residential address needs an appointment and a lift gate.
export function generateRecommendedAccessorialsForLocation(
  locationType: LocationType | undefined,
  accessorials: string[],
) {
  if (locationType === undefined) {
    return accessorials;
  }

  // Ensure that when a distribution warehouse is selected, that appointment is enforced
  if (locationType === LocationType.DistributionWarehouse) {
    return ensureAccessorialsContain(accessorials, [
      "SCHEDULING_APPOINTMENT_REQUIRED",
    ]);
  } else if (locationType === LocationType.Residential) {
    return ensureAccessorialsContain(accessorials, [
      "SCHEDULING_APPOINTMENT_REQUIRED",
      "LOGISTICS_LIFT_GATE_REQUIRED",
    ]);
  } else {
    return accessorials;
  }
}

// Inside pickup and inside delivery are business-location services — the driver
// goes past the receiving door of a warehouse or a shop. They are not white
// glove, so nobody carries freight into a house, and Operations decided we
// don't offer them for residential at all.
export function accessorialUnavailableForLocationType(
  locationType: LocationType | undefined,
  accessorial: string,
): boolean {
  return (
    locationType === LocationType.Residential &&
    accessorial === "LOGISTICS_INSIDE"
  );
}

/**
 * Drops the accessorials this location type can't have.
 *
 * Safe to run every time a location is set, unlike the recommendations above:
 * removing can't resurrect something the customer deliberately took off, and a
 * location often arrives already residential with inside still on it — a saved
 * address, or the address check deciding the address is a house.
 */
export function removeUnavailableAccessorialsForLocation(
  locationType: LocationType | undefined,
  accessorials: string[],
): string[] {
  return accessorials.filter(
    (a) => !accessorialUnavailableForLocationType(locationType, a),
  );
}
